import angular from 'angular';
import _ from 'lodash';

export const BuildCSVService = (RouteService, $filter) => {
    const csvHeaders = RouteService.getSystemPreference('csvCandidatesPrint');

    function flatten(data) {
        const result = {};

        function recurse(cur, prop) {
            if (Object(cur) !== cur) {
                result[prop] = cur;
            } else if (Array.isArray(cur)) {
                let l = cur.length;

                for (let i = 0, l = cur.length; i < l; i++) {
                    recurse(cur[i], `${prop}[${i}]`);
                }
                if (l === 0) {
                    result[prop] = [];
                }
            } else {
                let isEmpty = true;
                for (const p in cur) {
                    isEmpty = false;
                    recurse(cur[p], prop ? `${prop}.${p}` : p);
                }
                if (isEmpty && prop) {
                    result[prop] = {};
                }
            }
        }

        recurse(data, '');

        return result;
    }

    function buildExcelJson(candidate, csvHeaders) {
        const candidateJson = {};

        if (candidate) {
            for (let i = 0; i < csvHeaders.length; i++) {
                const header = csvHeaders[i];
                if (header.type === 'value') {
                    if (header.key.parentKey && header.key.childKey) {
                        candidateJson[header.columnName] = candidate[header.key.parentKey][header.key.childKey];
                    } else {
                        candidateJson[header.columnName] = candidate[header.key.parentKey];
                    }
                } else if (header.type === 'array') {
                    for (let j = 0; j < candidate[header.key.parentKey].length && j < header.count; j++) {
                        candidateJson[`${header.columnName}.${j}`] = buildExcelJson(candidate[header.key.parentKey][j], header.subColumns);
                    }
                } else if (header.type === 'arrayString') {
                    let arrayString = _.map(candidate[header.key.parentKey], header.key.childKey);
                    if (header.count !== -1) {
                        arrayString = arrayString.slice(0, header.count);
                    }
                    arrayString = arrayString.join(';');
                    candidateJson[header.columnName] = arrayString;
                }
            }
        }

        return flatten(candidateJson);
    }

    const getCsvHeaders = () => (csvHeaders || []).map(({ columnName }) => $filter('translate')(columnName));

    const createCsvFile = (candidates) =>
        (candidates.resultList || []).reduce((jsonExcel, candidate) => {
            if (candidate.check) {
                return [
                    ...jsonExcel,
                    buildExcelJson(candidate.candidateData, csvHeaders),
                ];
            }

            return jsonExcel;
        }, []);

    const getCsvFile = (candidates, csvColumns) =>
        (candidates || []).reduce((jsonExcel, candidate) => {
            return [
                ...jsonExcel,
                buildExcelJson(candidate, csvColumns),
            ];
        }, []);

    return {
        getCsvHeaders,
        createCsvFile,
        getCsvFile,
    };
};

angular
    .module('TALENYA-FE')
    .factory('buildCSVServiceNew', BuildCSVService);
